import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { WarrantyActivationFormService } from '@app/features/warranties/activate-warranty-process/steps/warranty-activation-form.service';

@Component({
    selector: 'app-activation-feedback',
    templateUrl: './activation-feedback.component.html',
    styleUrl: './activation-feedback.component.scss',
    host: {
        class: 'app-activation-feedback'
    },
    standalone: false
})
export class StepActivationFeedbackComponent implements OnInit {

  activatedSuccessfully: boolean = true;

  @Output() stepSaved = new EventEmitter<void>();

  constructor(
    private router: Router,
    public warrantyActivationFormService: WarrantyActivationFormService) { }

  ngOnInit() {
    const activationResult = this.warrantyActivationFormService.getStepData('activationResult');
    this.activatedSuccessfully = activationResult?.activationSuccess ?? false;
    this.warrantyActivationFormService.clearData();
  }

  onBackToWarranties() {
    this.router.navigate(['/warranties']);
  }
}
